import { useTranslation } from "react-i18next";

/**
 * Turns an ApiError into a user-facing message:
 * prefer the API `detail`, otherwise a translated generic message (briefing §8).
 */
export function useApiError() {
  const { t } = useTranslation();
  return (error) => {
    if (!error) return t("errors.generic");
    if (error.detail) return error.detail;
    if (error.messageKey) return t(error.messageKey);
    return t("errors.generic");
  };
}
